module.exports = __webpack_public_path__ + "img/layout_top_tree_right.86f092e6.svg";